module.exports = __webpack_public_path__ + "static/media/company-home-01.db5850e1.png";